var _path, _path2, _path3, _ellipse, _ellipse2, _path4, _path5, _path6, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStateNoCustomNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 187,
    viewBox: "0 0 256 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.595 173.459C186.642 173.459 211.858 173.459 202.402 87.8272C197.258 41.2485 170.438 8.5 125.176 8.5C79.9143 8.5 49.0009 31.0899 49.001 90.9793C52.1531 155.597 109.333 173.459 154.595 173.459ZM79.7749 38.2642C82.1078 41.1175 87.2373 40.7829 91.2319 37.5169C95.2265 34.2508 96.5736 29.2901 94.2407 26.4368C91.9078 23.5836 86.7783 23.9182 82.7837 27.1842C78.7891 30.4503 77.4421 35.411 79.7749 38.2642Z",
    fill: "url(#paint0_linear_51910_126546)",
    fillOpacity: 0.07
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 125C44.9583 87.0002 70.5 86.0003 84.5 87.0003C153 91.8931 185 113.5 198.5 121.5C235.5 143.426 243.5 190.737 157.5 186.5C56 181.5 38.5 149 41 125Z",
    fill: "url(#paint1_linear_51910_126546)",
    fillOpacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.736 5.05384C163.236 -4.94616 172.736 2.55384 175.236 5.05384C185.736 16.0538 189.736 33.0538 172.236 32.5538C154.736 32.0538 128.236 15.0538 145.736 5.05384Z",
    fill: "url(#paint2_linear_51910_126546)",
    fillOpacity: 0.15
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.9815,
    cy: 110.237,
    rx: 9.75579,
    ry: 13.6581,
    transform: "rotate(20.87 28.9815 110.237)",
    fill: "url(#paint3_linear_51910_126546)",
    fillOpacity: 0.15
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.1379,
    cy: 103.284,
    rx: 4.97707,
    ry: 6.9679,
    transform: "rotate(20.87 12.1379 103.284)",
    fill: "url(#paint4_linear_51910_126546)",
    fillOpacity: 0.15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1195 127.506C71.4923 130.133 73.353 134.625 77.0683 134.625H179.932C183.648 134.625 185.508 130.133 182.881 127.506C174.378 119.003 169.959 107.242 170.759 95.2435L171.557 83.2728C173.218 58.366 153.462 37.25 128.5 37.25C103.538 37.25 83.7831 58.366 85.4435 83.2728L86.2416 95.2435C87.0415 107.242 82.6228 119.003 74.1195 127.506ZM172.331 126.938C165.64 117.674 162.318 106.297 163.089 94.7321L163.887 82.7615C165.251 62.2917 149.016 44.9375 128.5 44.9375C107.985 44.9375 91.7494 62.2917 93.114 82.7615L93.912 94.7321C94.683 106.297 91.3609 117.674 84.6695 126.938H172.331Z",
    fill: "CURRENTCOLOR"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.5 148.719C117.886 148.719 109.281 140.114 109.281 129.5H116.969C116.969 135.869 122.131 141.031 128.5 141.031C134.869 141.031 140.031 135.869 140.031 129.5H147.719C147.719 140.114 139.114 148.719 128.5 148.719Z",
    fill: "CURRENTCOLOR"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.469 37.25V42.375H129.781V37.25C129.781 36.5424 129.208 35.9688 128.5 35.9688C127.792 35.9688 127.219 36.5424 127.219 37.25V42.375H119.531V37.25C119.531 32.2967 123.547 28.2812 128.5 28.2812C133.453 28.2812 137.469 32.2967 137.469 37.25Z",
    fill: "CURRENTCOLOR"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128.5,
    cy: 37.25,
    r: 5.125,
    fill: "CURRENTCOLOR"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51910_126546",
    x1: 121.171,
    y1: 164.722,
    x2: 38.9899,
    y2: 16.1745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "CURRENTCOLOR"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51910_126546",
    x1: 126.316,
    y1: 181.472,
    x2: 95.5145,
    y2: 72.5966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "CURRENTCOLOR"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_51910_126546",
    x1: 160.543,
    y1: 30.84,
    x2: 147.735,
    y2: -2.54611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "CURRENTCOLOR"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_51910_126546",
    x1: 28.2865,
    y1: 122.449,
    x2: 12.9886,
    y2: 101.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "CURRENTCOLOR"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_51910_126546",
    x1: 11.7834,
    y1: 109.514,
    x2: 3.97891,
    y2: 98.8183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "CURRENTCOLOR"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateNoCustomNotifications);
export default __webpack_public_path__ + "static/media/emptyStateNoCustomNotifications.c27b2f65.svg";
export { ForwardRef as ReactComponent };